import {
  PatientMedicationRecordEntryStatus,
} from './patient-medication-history.interface'
import { ErrorType, ErrorMessages } from './patient-medication-history.rest'

import type {
  MedicationRoute,
  MedicationDosageUnit,
  MedicationFrequencyUnit} from './patient-medication-history.interface';

export const getMedicationRouteLabelFromTypeId = (
  medicationRouteId: string,
  medicationRoutes: MedicationRoute[],
) => {
  const route = medicationRoutes.find((x) => x.id === medicationRouteId)

  return route?.name ?? medicationRouteId
}

export const getMedicationDosageLabelFromTypeId = (
  medicationDosageUnitId: string,
  medicationDosages: MedicationDosageUnit[],
) => {
  const dosage = medicationDosages.find((x) => x.id === medicationDosageUnitId)
  return dosage?.name ?? medicationDosageUnitId
}

export const getErrorFromErrorTypeId = (error: ErrorType) => {
  const errorMessageId = Object.keys(ErrorType).find(
    (key) => ErrorType[key] === error,
  )

  return errorMessageId
    ? ErrorMessages[errorMessageId]
    : ErrorMessages.unspecifiedError
}

export const getErrorLabel = (error: ErrorType) =>
  getErrorFromErrorTypeId(error)

export const getMedicationFrequencyLabelFromTypeId = (
  medicationFrequencyUnitId: string,
  medicationFrequencies: MedicationFrequencyUnit[],
) => {
  const frequency = medicationFrequencies.find(
    (x) => x.id === medicationFrequencyUnitId,
  )
  return frequency ? frequency.name : medicationFrequencyUnitId
}

export const getMedicationRecordStatusLabelFromId = (
  status: PatientMedicationRecordEntryStatus,
) => {
  switch (status) {
    case PatientMedicationRecordEntryStatus.Active:
      return 'Active'

    case PatientMedicationRecordEntryStatus.Discontinued:
      return 'Discontinued'

    default:
      return 'Status is not valid'
  }
}
